import React, {
  useEffect,
  useState,
  Fragment,
  useCallback,
  useRef,
  useContext,
} from 'react';
import { Progress, Row, Col } from 'antd';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useIndexedDB } from 'react-indexed-db';
import translationsUI from '../../ui/translationUI';
import {
  handleCheckingProgress,
  sendDisclosuresAnnouncementsData,
} from '~/utils/api';
import { RootLoadingContext } from '~/contextAPI/loadingContext';
import PaveLogo from '../PaveLogo';
import { reuploadImg } from '~/utils/reUploadMissing';
import { useWindowSize } from '~/utils/gestSizeDevice';
import { PaveColor } from '~/view/ui/components/ConfigStyle';
import { positionChecking } from '~/utils/checkPhotoStatus';
import { mapPhotoCodeToPosition } from '~/utils/reducerArr';
import { checkingEmptyObject } from '~/utils/checkingEmptyObj';
import { processOfflineFunction } from '~/utils/offlineFunctions';
import CameraComponent from '../../presentations/camera';
import {
  NETWORK_STATUS,
  PHOTOS_STATUS,
  SESSION_CHECK_TIMER,
} from '~/utils/config';
import * as networkActions from '~/state/actions/network/networkActions';
import * as userDetailsActions from '~/state/actions/userDetails/userDetailsActions';
import styled from 'styled-components';

const MissingReupload = (props) => {
  const {
    sessionID,
    localeFlag,
    netWorkData,
    networkAction,
    backgroundJob,
    userDetailsAction,
    userDetailsReducer,
    cameraSettingReducer,
  } = props;

  const statusRef = useRef(0);
  const getHeightElement = statusRef.current.clientHeight || 0;

  const intl = useIntl();
  const imgRef = useRef();
  const isLandscape = useWindowSize().width > useWindowSize().height;

  const screenWidth = useWindowSize().width - 30;

  let [missingLocal, setmissingLocal] = useState([]);
  let [runOneTime, setrunOneTime] = useState(false);
  const checkIndexdb = useIndexedDB('pwaPhotos');
  const { resetFollow } = userDetailsAction;
  const { statusFollowing, browserUserInfo } = userDetailsReducer;
  const { setloadingState } = useContext(RootLoadingContext);

  const handleLoadingAnimate = useCallback(() => {
    setloadingState((loadingContext) => ({
      ...loadingContext,
      state: true,
      reportChecking: true,
      isReceiveComponent: false,
      defaultMess: intl.formatMessage(translationsUI.PAVE_PROCESS_MESSAGE),
    }));
  }, [intl, setloadingState]);

  const checkingUploadOffline = async (arr) => {
    handleCheckingProgress(sessionID)
      .then(async (getResult) => {
        const { data } = !!getResult && getResult;
        const { photos } = !!data && data;
        const { finished, inspect } = !!photos && photos;
        const concatArr = [...finished, ...inspect];
        const getPhotosState =
          concatArr &&
          concatArr.length > 0 &&
          concatArr.map((item) => {
            return {
              state: parseInt(item.photoCode),
              status: item.status,
              passed: true,
              reason: PHOTOS_STATUS.MISSING,
              photoCodeUpload: parseInt(item.photoCode),
              position: mapPhotoCodeToPosition(parseInt(item.photoCode)),
              percent: 100,
              message: 'Uploaded',
              photoCode: parseInt(item.photoCode),
            };
          });
        if (!!checkIndexdb) {
          checkIndexdb
            .getAll()
            .then(
              async (getAllImgsOffline) => {
                if (!!getAllImgsOffline && getAllImgsOffline.length > 0) {
                  const hasPhotoReup = await processOfflineFunction(
                    sessionID,
                    [...getAllImgsOffline],
                    arr,
                    getResult,
                    intl,
                    localeFlag
                  );
                  if (!!hasPhotoReup && hasPhotoReup.length > 0) {
                    setmissingLocal(
                      getPhotosState && getPhotosState.length > 0
                        ? [...getPhotosState, ...hasPhotoReup]
                        : hasPhotoReup
                    );
                  } else if (
                    hasPhotoReup &&
                    hasPhotoReup.length === 0 &&
                    getPhotosState &&
                    getPhotosState.length > 0
                  ) {
                    setmissingLocal(getPhotosState);
                    setTimeout(() => {
                      handleLoadingAnimate();
                    }, 5000);
                  } else {
                    setTimeout(() => {
                      handleLoadingAnimate();
                    }, 2000);
                  }
                } else {
                  setmissingLocal(getPhotosState);
                  setTimeout(() => {
                    handleLoadingAnimate();
                  }, 5000);
                }
              },
              (error) => {
                console.log('then error', error);
                setmissingLocal(getPhotosState);
                setTimeout(() => {
                  handleLoadingAnimate();
                }, 5000);
              }
            )
            .catch(() => {
              console.log('full stored access');
            });
        }
        // fake promiseall
        // var p1 = Promise.resolve(3);
        // var p2 = 1337;
        // var p3 = new Promise((resolve, reject) => {
        //   setTimeout(() => {
        //     resolve('foo');
        //   }, 6000);
        // });

        // Promise.all([p1, p2, p3]).then((values) => {
        //   console.log(values); // [3, 1337, "foo"]
        //   setTimeout(() => {
        //     console.log('upload photos offline success');
        //     handleLoadingAnimate();
        //     reuploadD_A();
        //     resetFollow();
        //   }, SESSION_CHECK_TIMER);
        // });
        return true;
      })
      .catch(() => {
        setTimeout(() => {
          checkingUploadOffline([...backgroundJob]);
        }, 5000);
      });
  };

  useEffect(() => {
    let isMounted = true;
    async function doCheckingUploadOffline() {
      if (isMounted) {
        checkingUploadOffline([...backgroundJob]);
      }
    }

    doCheckingUploadOffline();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //init missing images list
  const handlePercent = useCallback(
    (code) => (progressEvent) => {
      const totalLength = progressEvent.lengthComputable
        ? progressEvent.total
        : progressEvent.target.getResponseHeader('content-length') ||
          progressEvent.target.getResponseHeader(
            'x-decompressed-content-length'
          );

      if (totalLength !== null) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / totalLength
        );
        const tempMissing = [...missingLocal];
        for (let x = 0; x < tempMissing.length; x++) {
          const element = tempMissing[x];
          if (parseInt(element.photoCodeUpload) === parseInt(code)) {
            element.percent = percentCompleted;
          }
        }
        setmissingLocal(tempMissing);
      }
    },
    [missingLocal]
  );

  //reupload Disclosures && Annnouncement
  const reuploadD_A = useCallback(() => {
    try {
      const { resetDataDisclosures, resetDataAnnouncements } = networkAction;
      const { offline_disclo, offline_announ } = netWorkData;
      setTimeout(() => {
        !!offline_disclo &&
          sendDisclosuresAnnouncementsData(offline_disclo, 'disclosures')
            .then(() => {
              resetDataDisclosures();
            })
            .catch((err) => console.log('err', err));
      }, 500);

      !!offline_announ &&
        sendDisclosuresAnnouncementsData(offline_announ, 'announcements')
          .then(() => {
            resetDataAnnouncements();
          })
          .catch((err) => console.log('err', err));
    } catch (error) {
      console.log('error', error);
    }
  }, [netWorkData, networkAction]);

  const handleReupload = async (items) => {
    try {
      setrunOneTime(true);
      let uploadAll = [];
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (!!checkIndexdb) {
          checkIndexdb
            .getByIndex('sessionkeyid', `${sessionID}_${item.photoCodeUpload}`)
            .then(
              (photo) => {
                if (!!photo && checkingEmptyObject(photo) === 'NOT_EMPTY') {
                  const config = handlePercent(photo.photoCode);
                  uploadAll.push(reuploadImg(photo, config));
                }
              },
              (err) => {
                console.log('error getindex', err);
              }
            )
            .catch((err) => console.log('get index err', err));
        }
      }
      Promise.all(uploadAll)
        .then((result) => {
          setTimeout(() => {
            handleLoadingAnimate();
            reuploadD_A();
            resetFollow();
          }, SESSION_CHECK_TIMER);
        })
        .catch((err) => {
          const arrTemp = (!!err && err.response) || {};
          if (arrTemp) {
            const data = arrTemp.data || {};
            console.log('catch-data-err', data);
          }
        });
    } catch (error) {
      console.log({ error });
    }
  };

  //auto upload images function
  useEffect(() => {
    let timer = null;
    try {
      timer = setTimeout(() => {
        const missingArr = [...missingLocal];
        !runOneTime &&
          missingArr &&
          missingArr.length > 0 &&
          handleReupload(missingArr);
      }, 5000);
    } catch (error) {
      console.log('error', error);
    }
    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [missingLocal, runOneTime]);

  return (
    <section style={{ width: '100%', height: 'calc(100vh)' }}>
      <div
        className="wrapp-img-custom animate-bottom"
        style={
          !!missingLocal && missingLocal.length > 0
            ? {
                margin: 0,
                padding: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                maxWidth: '100%',
                width: '100%',
                height: 85,
                overflow: 'hidden',
              }
            : {
                margin: 'auto',
                padding: '20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 'calc(100vh)',
              }
        }
      >
        <PaveLogo
          style={{
            height: '100%',
            maxWidth: 100,
          }}
        />
      </div>
      <Fragment>
        {statusFollowing === NETWORK_STATUS['JUST_ONLINE'] && (
          <div
            ref={statusRef}
            className="animate-bottom reupload-caption"
            style={{
              color: '#fff',
            }}
          >
            {intl.formatMessage(translationsUI.BACK_ONLINE_TRANSPHOTOS)}
          </div>
        )}
      </Fragment>
      <Fragment>
        {!!missingLocal && missingLocal.length > 0 && (
          <div
            className="missing-reupload-wrapper animate-bottom"
            style={{
              height:
                getHeightElement > 0
                  ? 'calc(100vh - 160px)'
                  : 'calc(100vh - 80px)',
            }}
          >
            <Row
              className="grid-container"
              justify="center"
              style={{ gap: 5 }}
              gutter={[0, 8]}
            >
              {missingLocal.map((item, index) => {
                return (
                  <Col
                    key={index}
                    className="missing-upload-item"
                    style={{
                      overflow: 'hidden',
                      padding: 0,
                      maxWidth: isLandscape ? screenWidth / 3 : screenWidth / 2,
                    }}
                    span={isLandscape ? 8 : 12}
                  >
                    <div
                      className={`${
                        item && item.percent === 100
                          ? 'contents-custom'
                          : 'contents'
                      } `}
                    >
                      <Fragment>
                        {item && item.percent > 0 && item.percent < 100 && (
                          <Fragment>
                            <div className="btn-reupload item">
                              <div
                                className={`${
                                  item.percent > 0 && item.percent < 100
                                    ? 'animation-loader wrap-icon-green'
                                    : ''
                                } wrap-icon wrap-icon-violet`}
                              >
                                <i className="fas fa-sync-alt"></i>
                              </div>
                            </div>
                          </Fragment>
                        )}
                      </Fragment>
                      <Fragment>
                        {item && item.percent === 100 && (
                          <Fragment>
                            <div className="btn-reupload item">
                              <div className="wrap-icon wrap-icon-green">
                                <i className="fas fa-sync-alt"></i>
                              </div>
                            </div>
                          </Fragment>
                        )}
                      </Fragment>
                      <Fragment>
                        {item && item.percent === 0 && (
                          <Fragment>
                            <div className="btn-reupload item">
                              <div className="wrap-icon">
                                <i className="fas fa-sync-alt"></i>
                              </div>
                            </div>
                          </Fragment>
                        )}
                      </Fragment>
                      <div
                        className="content-center item"
                        style={
                          isLandscape
                            ? {
                                maxWidth: '120px',
                                width: '100%',
                                overflow: 'hidden',
                              }
                            : {
                                marginLeft: '10px',
                                maxWidth: '120px',
                                width: '100%',
                                overflow: 'hidden',
                              }
                        }
                      >
                        <div
                          className={`label-name ${
                            item &&
                            item.position &&
                            positionChecking(item.position)
                              ? 'animation-right-to-left-photos-offline'
                              : ''
                          } `}
                        >
                          {item && item.position}
                        </div>
                        <div className="status">
                          {item.percent === 0 ? (
                            <span className="default">
                              {item.status === PHOTOS_STATUS.MISSING ? (
                                <Fragment>
                                  {intl.formatMessage(
                                    translationsUI.OFFLINE_PROCESS_MISSING
                                  )}
                                </Fragment>
                              ) : (
                                <Fragment>
                                  {intl.formatMessage(
                                    translationsUI.OFFLINE_PROCESS_MISSING
                                  )}
                                </Fragment>
                              )}
                            </span>
                          ) : item.percent > 0 && item.percent < 100 ? (
                            <span className="transferring">
                              {intl.formatMessage(
                                translationsUI.OFFLINE_PROCESS_TRANSFERRING
                              )}
                            </span>
                          ) : (
                            <span className="sent">
                              {intl.formatMessage(
                                translationsUI.OFFLINE_PROCESS_SENT
                              )}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <Progress
                      percent={item.percent}
                      showInfo={false}
                      className={`custom-progressbar ${
                        isLandscape ? '' : 'custom-progressbar-isportrait'
                      }`}
                      strokeColor={`${
                        item.percent > 0 && item.percent < 100
                          ? PaveColor.primary_violet
                          : PaveColor.primary_green
                      }`}
                    />
                    <div className="text-over">
                      <div className="wrapp-text-over">
                        <span
                          className="status-caption"
                          style={{
                            color:
                              item.percent === 0
                                ? 'rgba($color: #000000, $alpha: 0.7)'
                                : '#fff',
                          }}
                        >
                          {intl.formatMessage(
                            translationsUI.OFFLINE_PROCESS_STATUS
                          )}
                          :
                        </span>
                        <Fragment>
                          {item.percent === 0 ? (
                            <Fragment>
                              <span className="default-bottom-caption">
                                {intl.formatMessage(
                                  translationsUI.OFFLINE_PROCESS_WATTING
                                )}
                              </span>
                            </Fragment>
                          ) : item.percent > 0 && item.percent < 100 ? (
                            <Fragment>
                              <span className="transferring-bottom-caption">
                                {intl.formatMessage(
                                  translationsUI.OFFLINE_PROCESS_TRANSFERRING
                                )}
                              </span>
                            </Fragment>
                          ) : (
                            <Fragment>
                              <span className="sent-bottom-caption">
                                {intl.formatMessage(
                                  translationsUI.OFFLINE_PROCESS_SENT
                                )}
                              </span>
                            </Fragment>
                          )}
                        </Fragment>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        )}
      </Fragment>
      <div
        style={{
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          zIndex: '-1',
          width: '100%',
          position: 'absolute',
          height: '100%',
        }}
      >
        <CameraComponent
          zIndex="-1"
          imgRef={imgRef}
          cameraSetting={cameraSettingReducer}
          os={browserUserInfo?.os?.name}
        />
        <BlurComponent />
      </div>
    </section>
  );
};
const mapStateToProps = (state) => ({
  netWorkData: state.networkReducer,
  sessionID: state.session.sessionKey,
  backgroundJob: state.backgroundJobReducer,
  userDetailsReducer: state.userDetailsReducer,
  localeFlag: state.languageProviderReducer.locale,
  cameraSettingReducer: state.cameraSettingReducer,
});

const mapDispatchToProps = (dispatch) => ({
  networkAction: bindActionCreators(networkActions, dispatch),
  userDetailsAction: bindActionCreators(userDetailsActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(MissingReupload));

const BlurComponent = styled.div`
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 110vh;
  width: 100%;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.5);
`;
